export default __webpack_public_path__ + "static/media/5.1be7b872.png";